import auth from '@/helpers/auth';

export default {
	noAuth(config) {
		return config;
	},

	auth(config) {
		const token = auth.getToken();
		config.headers.token = `${token}`;

		return config;
	},

	onError(err) {
		return Promise.reject(err);
	},
};
